export enum EDentalNotation {
    FDI_NOTATION = 'fdi_notation',
    UNIVERSAL_SYSTEM = 'universal_system',
    PALMER_NOTATION = 'palmer_notation',
}
